type Props = {
  date: string;
};

export function FormattedDate(props: Props) {
  const date = new Date(props.date);

  const { isoString, formattedDate } = (() => {
    try {
      if (date.toString() === 'Invalid Date') {
        return { isoString: undefined, formattedDate: '' };
      }

      const isoString = date.toISOString();
      const formattedDate = date.toLocaleDateString('en-us', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      });

      return { isoString, formattedDate };
    } catch (error) {
      console.error('Error formatting date', {
        date,
        error,
      });

      return { isoString: undefined, formattedDate: '' };
    }
  })();

  return <time dateTime={isoString}>{formattedDate}</time>;
}
